import React, { useContext } from 'react'

import { fetchTrackingCodes } from '../API';

// store
import types from '../store/types'


const useCustomTracking = (dispatch) => {

  const getTrackingCodes = async (clubID) => {
    const res = await fetchTrackingCodes(clubID);

    if (res && res?.trackingItems?.length > 0) {
      res.trackingItems.map((item) => {
        const fragment = document.createRange().createContextualFragment(
          `${item?.trackingCode}` // tracking code should include script tags
        );
        return document.head.appendChild(fragment); // the tracking code will be added ones in the head
      });
      dispatch({ type: types.SET_CUSTOM_TRIGGER, payload: true })
    }
  };

  return getTrackingCodes
}

export default useCustomTracking